"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";

/** Einzelner Link im Mega-Menü – Hover-Farbe kommt vom Spalten-Thema. */
export default function MegaMenuLink({
  href,
  children,
  onNavigate,
  className,
}: {
  href: string;
  children: React.ReactNode;
  onNavigate?: () => void;
  className?: string;
}) {
  return (
    <Link
      href={href}
      onClick={onNavigate}
      className={cn(
        "block truncate py-2 text-sm text-ink transition-colors duration-150",
        className
      )}
    >
      {children}
    </Link>
  );
}
